import { render, staticRenderFns } from "./ModalPenyimpanan.vue?vue&type=template&id=3c2bced3&"
import script from "./ModalPenyimpanan.vue?vue&type=script&lang=js&"
export * from "./ModalPenyimpanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports